import React from 'react';

function CustomCard({ children, className, style }) {
  return (
    <div className={`col-sm-12 col-md-12 note-section ${className || ''}`}>
      <div className='card note-section-header' style={{ ...(style || {}) }}>
        {children}
      </div>
    </div>
  );
}

export default CustomCard;



// WEBPACK FOOTER //
// ./src/Components-2025/Notes/CustomCard.jsx